/**
 * v9 replacement for the removed `@material-ui/core/withWidth`.
 *
 * MUI v5+ dropped the `withWidth` HOC in favor of the `useMediaQuery` hook.
 * The migration initially stubbed it as `width="xs"` to keep things compiling
 * (see the FIXME comments removed by the commit that introduced this file),
 * but the stub forced every consumer into the mobile branch on every
 * viewport — collapsing the portfolio donut chart to 135px and leaving a
 * 100px white band inside the chart card on desktop.
 *
 * This implementation mirrors MUI's official migration recipe:
 *   https://mui.com/components/use-media-query/#migrating-from-withwidth
 *
 * Usage (unchanged from the v4 API):
 *
 *   import { withWidth } from '../../utils/withWidth';
 *   export default withWidth()(MyComponent);
 *
 * MyComponent then receives a `width` prop whose value is one of
 * 'xs' | 'sm' | 'md' | 'lg' | 'xl', matching the current viewport's
 * largest active breakpoint.
 */
import React from 'react';
import { useWidth } from './hooks';

export { useWidth };

export const withWidth = () => WrappedComponent => {
  const WithWidth = props => {
    const width = useWidth();
    return <WrappedComponent {...props} width={width} />;
  };
  WithWidth.displayName = `WithWidth(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  return WithWidth;
};

export default withWidth;
